import React from "react";
import { BOLearning } from "../../../Mock/Learn";
import SecondaryHeading from "../../../utils/SecondaryHeading/SecondaryHeading";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import Timer from "../../../main/Timer/Timer";

const LearningBenefits = () => {
  return (
    <section className="max-w-7xl m-auto mt-16 max-sm:px-5">
      <div className="mb-10 flex justify-center">
        <SecondaryHeading>Benefits of Learning with Us</SecondaryHeading>
      </div>
      <div className="flex flex-wrap gap-8 justify-center">
        {BOLearning.map((val, index) => (
          <Child key={index} {...val} index={index} />
        ))}
      </div>
      <div className="flex justify-center flex-col items-center mt-10">
        <Timer/>
        <PrimaryBtn>Unlock Your Learning</PrimaryBtn>
      </div>
    </section>
  );
};

export default LearningBenefits;

const Child = ({ icon, title, para, index, bgColor }) => {
  return (
    <div
      style={{ backgroundColor: bgColor }}
      className=" text-white w-[23%] py-10 px-6 flex justify-center flex-col items-center rounded-tr-2xl rounded-bl-2xl  max-sm:w-[100%]">
      <img className="w-20 mb-5" src={icon} alt="icon" />
      <h3 className="mb-4 text-lg text-textColor font-semibold text-center max-sm:text-base">
        {" "}
        <span>{index + 1}.</span> {title}
      </h3>
      <p className="text-center  text-textColor font-medium max-sm:text-sm">
        {para}
      </p>
    </div>
  );
};
